import EfImg from '@elem/ui/ef-img';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import getLocal from '@/app/utils/getLocal';

let maskSceneL: any = null,
    titleSceneL: any = null;

const SectionB2 = () => {
    const { locale } = getLocal();
    const { useLang, useEffect, useState } = useGlobal();
    const { t } = useLang('theProduct.SectionB2');

    const [textEnter, setTextEnter] = useState(false);

    const bannerMap = {
        us: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1743081347469/plug.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1743081347469/plug.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1743081350429/plug_h5.jpg',
        },
    };

    const bannerImage = bannerMap[locale as keyof typeof bannerMap];

    useEffect(() => {
        if (!['uk', 'it'].includes(locale) && typeof window !== 'undefined') {
            const resizeAni = () => {
                if (maskSceneL) {
                    AniContainer.removeScene(maskSceneL);
                    maskSceneL = null;
                }
                if (titleSceneL) {
                    AniContainer.removeScene(titleSceneL);
                    titleSceneL = null;
                }

                const pageHeight = window.innerHeight;
                const clientH = (pageHeight || 0) * 0.2;

                const startH = window?.innerWidth <= 1024 ? -(pageHeight * 0.1) : Math.min(clientH, 150);

                maskSceneL = AniContainer.create({
                    triggerElement: '.detail-L1',
                    triggerHook: 1,
                    offset: startH,
                    duration: '17%',
                    onEnter: () => {
                        setTextEnter(true);
                        if (!titleSceneL) {
                            titleSceneL = AniContainer.create({
                                syncFromTo: [['.detail-L1 .annimate-step', { opacity: 0 }, { opacity: 1 }, 2]],
                                triggerElement: '.detail-L1',
                                triggerHook: 1,
                                offset: '105%',
                                duration: '11%',
                            });
                        }
                    },
                });
            };

            resizeAni();
            // window.addEventListener('resize', resizeAni);
            return () => {
                if (maskSceneL) {
                    AniContainer.removeScene(maskSceneL);
                    maskSceneL = null;
                }
                if (titleSceneL) {
                    AniContainer.removeScene(titleSceneL);
                    titleSceneL = null;
                }
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, [locale]);

    if (['uk', 'it'].includes(locale)) return null; // uk和it暂时不显示

    return (
        <section className={`detail-L1 dpu-detail-section ${css['detail-L1']}`}>
            <div className={`sticky-box${textEnter ? ' textEnter' : ''}`}>
                <div className="img-box">
                    <EfImg pc={bannerImage.pc} pad={bannerImage.pad} h5={bannerImage.h5} alt={t('title')} />
                    <div className="annimate-step">
                        <div className="mask"></div>
                        <div className="title-box">
                            <h2 className="title">{t('title')}</h2>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
export default SectionB2;
